import BaseTool from '@/components/geoview/tools/BaseTool'

class Pointer extends BaseTool {
  async onClick (e) {
    let layerNames = []
    for (let layerId in this.mapHelper.layers) {
      if (!this.mapHelper.layers.hasOwnProperty(layerId)) {
        return
      }
      layerNames.push(this.mapHelper.layers[layerId].getLayerId())
    }
    let f = this.getMap().queryRenderedFeatures(e.point, { layers: layerNames })

    if (f.length === 0) {
      return
    }

    if (typeof this.mapHelper.onObjectsSelect === 'function') {
      this.getMap().setFeatureState({ source: f[0].source, id: f[0].id }, { selected: true })
      await this.mapHelper.onObjectsSelect(f[0])
      // nach dem schließen der TB wieder deselectieren
      if (this.getMap().getSource(f[0].source)) {
        this.getMap().setFeatureState({ source: f[0].source, id: f[0].id }, { selected: false })
      }
    }
  }
}

export default Pointer
